import React from 'react';
import ReactDOM from 'react-dom';
import Read from './modules/Read/Read';
import Count from './modules/Count/Count';

import './index.scss';

const root = document.getElementById('testRoot');

let testComponent = null;
let testType = root.dataset.test;

switch(testType) {
  case 'read':
    testComponent = <Read />
    break;
  case 'count':
    testComponent = <Count />
    break;
  default:
    testComponent = null
    break;
}

ReactDOM.render(testComponent, root);
